import React, { useState, useEffect, useRef  } from 'react';
import { Card, Button, Container, Row, Col,Modal,Form} from 'react-bootstrap';
import styled from 'styled-components';
import CandlestickChart from '../../charts/lightweightcharts/CandlestickChart';
import TradingViewLiveChart from '../../charts/lightweightcharts/TradingViewLiveChart';

import TradingViewAdvancedChart from '../../charts/advancedcharts/TradingViewAdvancedChart';
import aiResponses from '../../data/onboarding-ai-responses'; // ✅ Modular AI response import

import candlestickData from '../../data/onboarding-candlestick-data'; 

import LearnWithAI from '../../components/ai/LearnWithAI';

import AnswerFeedback from '../../components/practicesession/AnswerFeedback';

import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';


// Styled Components
const StyledContainer = styled(Container)`
  background-color: #232830;
  color: #ffffff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

const StyledHeading = styled.h2`
  font-size: 22px;
  font-weight: bold;
  color: #ff7c24;
  margin-bottom: 20px;
  text-align: center;
  margin-top: 10px;
`;

const QuestionText = styled.h3`
  font-size: 20px;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
  margin-bottom: 20px;
`;

const StyledCard = styled(Card)`
  background-color: ${(props) =>
    props.selected ? (props.isCorrect ? '#2ECC71' : '#FF4C4C') : '#FFFFFF'};
  color: ${(props) => (props.selected ? '#FFFFFF' : '#232830')};
  border-radius: 15px;
  padding: 15px;
  margin-bottom: 10px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  &:hover {
    transform: scale(1.02);
  }
`;

// Styled Button for "Learn with AI"
const AIButton = styled(Button)`
  background-color: #007bff;
  border-color: #007bff;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  border-radius: 12px;
  padding: 12px;
  width: 80%;
  max-width: 300px;
  margin-top: 10px;
  &:hover {
    background-color: #0056b3;
    border-color: #0056b3;
  }
`;
const UpgradeContainer = styled.div`
  padding: 20px;
  background-color: rgba(0, 0, 255, 0.7);
  border-radius: 8px;
  color: #ffffff;
  text-align: left;
  margin-top: 15px;
`;
const UpgradeButton = styled(Button)`
background-color: #ff7c24;
border-color: #ff7c24;
font-size: 18px;
font-weight: bold;
padding: 12px;
width: 100%;
margin-top: 10px;
&:hover {
  background-color: #e66a1a;
  border-color: #e66a1a;
}
`;
const handleUpgradeClick = () => {
    window.open("https://buy.stripe.com/eVa29y1Ig8zsgFycMZ", "_blank", "noopener,noreferrer");
  };
const SendButton = styled(Button)`
  background-color: var(--main-orange);
  border-color: var(--main-orange);
  color: var(--main-white);
  font-size: 16px;
  font-weight: bold;
  border-radius: 8px;
  padding: 10px 20px;
  &:hover {
    background-color: var(--main-black);
    border-color: var(--main-black);
  }
`;










const OnboardingMultipleChoiceQuestionChart = ({ question, onNext }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [isCorrect, setIsCorrect] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);


  const [showAIChat, setShowAIChat] = useState(false);
  const [messages, setMessages] = useState([]);
  const [userMessage, setUserMessage] = useState('');
  const [userMessageCount, setUserMessageCount] = useState(0);
  const [showUpgradeOverlay, setShowUpgradeOverlay] = useState(false);
  const chatEndRef = useRef(null);


  const db = getFirestore();
  const auth = getAuth();



  const optionRefs = useRef([]);
  const maxWidth = '100%'; // Adjust this based on your layout



  // Sample candlestick data – update with full data from your iOS implementation


    
    



  // const handleOptionSelect = (index) => {
  //   if (!showFeedback) {
  //     setSelectedOption(index);
  //     const correct = index.toString() === question.correctanswer;
  //     setIsCorrect(correct);
  //     setShowFeedback(true);
  //   }
  // };

  const handleContinue = async () => {
    try {
      const currentUser = auth.currentUser;
  
      await addDoc(collection(db, 'userpracticesessionanswers'), {
        date: serverTimestamp(),
        lessonid: question.lessonid,
        questionid: question.questionid,
        submittedanswerid: `${selectedOption}`,
        userid: currentUser ? currentUser.uid : 'anonymous',
        sessiontype: "onboarding",
        iscorrect: isCorrect,
      });
  
      console.log("✅ Answer stored in Firestore:", selectedOption);
    } catch (error) {
      console.error("❌ Error saving answer:", error);
    }
  
    onNext(isCorrect);
    setShowFeedback(false);
    setSelectedOption(null);
    setIsCorrect(false);
  };

  const getIconNameForKeyword = (text) => {
    const lowerText = text.toLowerCase();
    if (lowerText.includes("allocate")) return "allocate";
    if (lowerText.includes("avoid")) return "avoid";
    if (lowerText.includes("bid")) return "bid";
    if (lowerText.includes("buy")) return "buy";
    if (lowerText.includes("breakout")) return "breakout";
    if (lowerText.includes("sell")) return "sell";
    if (lowerText.includes("calm")) return "calm";
    if (lowerText.includes("cancel")) return "cancel";
    if (lowerText.includes("commodity")) return "commodity";
    if (lowerText.includes("diversify")) return "diversify";
    if (lowerText.includes("expired")) return "expired";
    if (lowerText.includes("financial")) return "financial";
    if (lowerText.includes("fomo")) return "fomo";
    if (lowerText.includes("forex")) return "forex";
    if (lowerText.includes("hedge")) return "hedge";
    if (lowerText.includes("hold")) return "hold";
    if (lowerText.includes("invest")) return "invest";
    if (lowerText.includes("lock funds")) return "lock-funds";
    if (lowerText.includes("modify")) return "modify";
    if (lowerText.includes("options")) return "options";
    if (lowerText.includes("review")) return "review";
    if (lowerText.includes("reversal")) return "reversal";
    if (lowerText.includes("risk")) return "risk";
    if (lowerText.includes("reduce")) return "reduce";
    if (lowerText.includes("salary")) return "salary";
    if (lowerText.includes("scalp")) return "scalp";
    if (lowerText.includes("stock")) return "stock";
    if (lowerText.includes("stop")) return "stop";
    if (lowerText.includes("stop-loss")) return "stop-loss";
    if (lowerText.includes("test")) return "test";
    if (lowerText.includes("trade")) return "trade";
    if (lowerText.includes("wait")) return "wait";
    if (lowerText.includes("yen")) return "yen";
    if (lowerText.includes("exit")) return "exit";
    if (lowerText.includes("dollar")) return "dollar";
    if (lowerText.includes("etf")) return "etf";
    if (lowerText.includes("pnl")) return "pnl";
    if (lowerText.includes("fear")) return "fear";
    if (lowerText.includes("paper")) return "paper";
    if (lowerText.includes("moon")) return "moon";
    if (lowerText.includes("milk")) return "milk";
    if (lowerText.includes("grain")) return "grain";
    if (lowerText.includes("plus")) return "plus";
    if (lowerText.includes("roll")) return "roll";
    if (lowerText.includes("short")) return "short";
    if (lowerText.includes("top-up")) return "top-up";
  
    const defaults = ["default-1", "default-2", "default-3", "default-4", "default-5"];
    return defaults[Math.floor(Math.random() * defaults.length)];
  };


  const AnswerOptionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
`;



const IconImage = styled.img`
  width: 40px;
  height: 40px;
`;


 useEffect(() => {
   if (showAIChat && messages.length > 0) {
     chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
   }
 }, [messages]);

//  const handleOptionSelect = (index) => {
//    if (!showFeedback) {
//      setSelectedOption(index);
//      const correct = index.toString() === question.correctanswer;
//      setIsCorrect(correct);
//      setShowFeedback(true);
//    }
//  };

const handleOptionSelect = (index) => {
  if (!showFeedback) {
    const selectedAnswerIndex = index + 1; // Convert zero-based index to one-based for comparison
    setSelectedOption(selectedAnswerIndex);
    
    const correct = selectedAnswerIndex.toString() === question.correctanswer; // Ensure correct comparison
    setIsCorrect(correct);
    setShowFeedback(true);
  }
};




 const handleLearnWithAI = () => {
   setShowAIChat(true);
   setMessages([
     { sender: 'ai', text: `Learn with AI: Ask me anything about ${question.questionname}` }
   ]);
 };

 const handleSendMessage = () => {
   if (userMessage.trim() === '') return;

   setMessages((prevMessages) => [
     ...prevMessages,
     { sender: 'user', text: userMessage }
   ]);
   setUserMessage('');
   setUserMessageCount((count) => count + 1);

   setTimeout(() => {
     const responseList = aiResponses[question.questionid] || [];
     const responseIndex = userMessageCount < responseList.length ? userMessageCount : responseList.length - 1;
     //const responseText = responseList.length > 0 ? responseList[responseIndex] : "That's an interesting question! Let's explore more together.";
     const responseText = responseList.length > 0 
     ? responseList[Math.floor(Math.random() * responseList.length)]  // Pick a random response
     : "You have hit AI messages iimit. Upgrade to continue";


     setMessages((prevMessages) => [
       ...prevMessages,
       { sender: 'ai', text: responseText }
     ]);
   }, 1500);
 };


  return (
    <StyledContainer>
      {/* <StyledHeading>Make your Move? </StyledHeading> */}
      <QuestionText>{question.questionname}</QuestionText>

      {/* Render the candlestick chart with the provided data */}
      <CandlestickChart data={candlestickData} />

       {/* Render the live chart - Widget */}
      {/* <TradingViewLiveChart symbol="BTCUSD" /> */}

      {/* Render the Advanced chart - Widget */}

      {/* Render the Advanced TradingView Chart */}
{/* <TradingViewAdvancedChart /> */}

     



      





      {/* Vertical Spacing Added Here */}
<div style={{ marginTop: '40px' }} />

      {/* <Row className="g-3" style={{ marginTop: '20px' }}>
        {[1, 2, 3, 4].map((index) => {
          const option = question[`answeroption${index}`];
          if (!option) return null;

          return (
            <Col xs={12} key={index}>
              <StyledCard
                onClick={() => handleOptionSelect(index)}
                selected={selectedOption === index}
                isCorrect={isCorrect}
              >
                {option}
              </StyledCard>
            </Col>
          );
        })}
      </Row> */}


{/* <Row className="g-3">
  {[1, 2, 3, 4].map((index) => {
    const option = question[`answeroption${index}`];
    if (!option) return null;

    const iconName = getIconNameForKeyword(option);
    return (
      <Col xs={6} key={index}>
        <StyledCard 
          onClick={() => handleOptionSelect(index)} 
          selected={selectedOption === index}
          style={{ padding: '10px', fontSize: '16px' }}
        >
          <AnswerOptionContainer>
            <IconImage src={`/assets/icons-answer-options/${iconName}.png`} alt={option} />
            <span>{option}</span>
          </AnswerOptionContainer>
        </StyledCard>
      </Col>
    );
  })}
</Row> */}


{/* First Row of Answer Options */}
<Row className="g-3">
  {[1, 2].map((index) => {
    const option = question[`answeroption${index}`];
    if (!option) return null;

    const iconName = getIconNameForKeyword(option);
    return (
      <Col xs={6} key={index}>
        <StyledCard
          ref={(el) => (optionRefs.current[index - 1] = el)} // Adjust for 1-based index
          onClick={() => handleOptionSelect(index - 1)} // Adjust for zero-based handling
          selected={selectedOption === index} // Ensure selection logic aligns with JSON
          isCorrect={selectedOption === index && isCorrect} // Ensure correct answer highlights green
          style={{ padding: '10px', fontSize: '16px' }}
        >
          <AnswerOptionContainer width={maxWidth}>
            <IconImage src={`/assets/icons-answer-options/${iconName}.png`} alt={option} />
            <span>{option}</span>
          </AnswerOptionContainer>
        </StyledCard>
      </Col>
    );
  })}
</Row>

{/* Vertical Spacing between Rows */}
<div style={{ marginTop: '15px' }} />

{/* Second Row of Answer Options */}
<Row className="g-3">
  {[3, 4].map((index) => {
    const option = question[`answeroption${index}`];
    if (!option) return null;

    const iconName = getIconNameForKeyword(option);
    return (
      <Col xs={6} key={index}>
        <StyledCard
          ref={(el) => (optionRefs.current[index - 1] = el)} // Adjust for 1-based index
          onClick={() => handleOptionSelect(index - 1)} // Adjust for zero-based handling
          selected={selectedOption === index} // Ensure selection logic aligns with JSON
          isCorrect={selectedOption === index && isCorrect} // Ensure correct answer highlights green
          style={{ padding: '10px', fontSize: '16px' }}
        >
          <AnswerOptionContainer width={maxWidth}>
            <IconImage src={`/assets/icons-answer-options/${iconName}.png`} alt={option} />
            <span>{option}</span>
          </AnswerOptionContainer>
        </StyledCard>
      </Col>
    );
  })}
</Row>










{showFeedback && (
  <>

 {/* Display feedback message based on correctness */}
 <p style={{ 
      fontSize: '18px', 
      fontWeight: 'bold', 
      color: isCorrect ? '#2ECC71' : '#FF4C4C', 
      textAlign: 'center',
      marginBottom: '10px'
    }}>
      {isCorrect ? "✅ Well done!" : "❌ Incorrect answer"}
    </p>




    {/* {!isCorrect && <AIButton onClick={handleLearnWithAI}>Learn with AI</AIButton>} */}

    <AIButton onClick={handleLearnWithAI}>Learn with AI</AIButton>
    
    <Button
      onClick={handleContinue}
      style={{
        backgroundColor: '#FF7C24',
        width: '100%',
        marginTop: '20px',
        fontSize: '18px',
        fontWeight: 'bold',
        borderRadius: '10px',
        padding: '12px 30px',
      }}
    >
      Continue
    </Button>
  </>
)}

{showFeedback && (
        <>
    {/* Display feedback message based on correctness */}
    <p style={{ 
      fontSize: '18px', 
      fontWeight: 'bold', 
      color: isCorrect ? '#2ECC71' : '#FF4C4C', 
      textAlign: 'center',
      marginBottom: '10px'
    }}>
      {isCorrect ? "✅ Well done!" : "❌ Incorrect answer"}
    </p>
        </>
      )}




  {/* AI Chat Modal */}
     <LearnWithAI
  show={showAIChat}
  onClose={() => setShowAIChat(false)}
  question={question}
  isCorrect={isCorrect}
/>

    </StyledContainer>
  );
};

export default OnboardingMultipleChoiceQuestionChart;





// import React, { useState, useEffect } from "react";
// import { getFirestore, collection, getDocs, query, where } from "firebase/firestore";
// import { useNavigate } from "react-router-dom";
// import Logout from "../../Logout"; // Corrected path for Logout
// import OnboardingMultipleChoiceQuestion from "./OnboardingMultipleChoiceQuestion"; // Standard MCQ
// import OnboardingMultipleChoiceQuestionChart from "./OnboardingMultipleChoiceQuestionChart"; // Chart-Based MCQ
// import OnboardingTrueFalseQuestion from "./OnboardingTrueFalseQuestion"; // True/False
// import OnboardingMatchTheFollowingQuestion from "./OnboardingMatchTheFollowingQuestion"; // Match the Following
// import { ProgressBar } from "react-bootstrap";
// import { FaChartBar } from "react-icons/fa";

// const MAX_INCORRECT = 20;

// const OnboardingSkillTest = () => {
//   const [questions, setQuestions] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [incorrectCount, setIncorrectCount] = useState(0);
//   const [showProSubscription, setShowProSubscription] = useState(false);
//   const navigate = useNavigate();

//   // Set dark background on mount
//   useEffect(() => {
//     document.body.style.backgroundColor = "#000";
//     document.body.style.color = "#fff";
//     return () => {
//       document.body.style.backgroundColor = "";
//       document.body.style.color = "";
//     };
//   }, []);

//   // Load incorrect answer count from localStorage
//   useEffect(() => {
//     let incorrectAnswers = parseInt(localStorage.getItem("incorrectAnswerCount")) || 0;
//     let lastAttemptTimestamp = parseInt(localStorage.getItem("lastAttemptTimestamp")) || 0;
//     let currentTimestamp = Date.now();
//     if (lastAttemptTimestamp && currentTimestamp - lastAttemptTimestamp > 24 * 60 * 60 * 1000) {
//       localStorage.setItem("incorrectAnswerCount", "0");
//       incorrectAnswers = 0;
//     }
//     setIncorrectCount(incorrectAnswers);
//     if (incorrectAnswers >= MAX_INCORRECT) {
//       setShowProSubscription(true);
//     }
//   }, []);

//   // Fetch onboarding skill test questions from Firebase (lessonid = "1.0")
//   useEffect(() => {
//     const fetchQuestions = async () => {
//       const db = getFirestore();
//       try {
//         const q = query(
//           collection(db, "questions_new"),
//           where("lessonid", "==", "1.0"),
//           where("questiontypeid", "in", ["1", "2", "3", "6.1"]),
//           where("active", "==", "0")
//         );
//         const snapshot = await getDocs(q);
//         const lessonQuestions = snapshot.docs.map((doc) => doc.data());
//         setQuestions(lessonQuestions);
//       } catch (error) {
//         console.error("❌ Error fetching questions:", error);
//       }
//     };
//     fetchQuestions();
//   }, []);

//   // Handle answer result
//   const handleAnswerResult = (isAnswerCorrect) => {
//     if (!isAnswerCorrect) {
//       let incorrectAnswers = incorrectCount + 1;
//       localStorage.setItem("incorrectAnswerCount", incorrectAnswers);
//       localStorage.setItem("lastAttemptTimestamp", Date.now().toString());
//       setIncorrectCount(incorrectAnswers);
//       if (incorrectAnswers >= MAX_INCORRECT && !showProSubscription) {
//         setShowProSubscription(true);
//         return;
//       }
//     }
//     handleNext();
//   };

//   // Move to next question or finish quiz
//   const handleNext = () => {
//     if (currentIndex < questions.length - 1) {
//       setCurrentIndex(currentIndex + 1);
//     } else {
//       navigate("/post-activation-quote");
//     }
//   };

//   const currentQuestion = questions[currentIndex];

//   return (
//     <>
//       {/* Progress Bar */}
//       <div
//         style={{
//           width: "100vw",
//           backgroundColor: "#000",
//           padding: "10px 0",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           position: "relative",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             gap: "8px",
//             width: "50%",
//           }}
//         >
//           <ProgressBar
//             now={((currentIndex + 1) / questions.length) * 100}
//             variant="success"
//             style={{
//               width: "40%",
//               height: "6px",
//               borderRadius: "5px",
//               backgroundColor: "#000",
//             }}
//           />
//         </div>
//       </div>

//       {/* Quiz Content */}
//       <div
//         style={{
//           fontFamily: "Nunito Sans",
//           minHeight: "100vh",
//           padding: "20px",
//           position: "relative",
//           backgroundColor: "#000",
//           color: "#fff",
//         }}
//       >
//         {currentQuestion ? (
//           <>
//             {currentQuestion.questiontypeid === "1" && (
//               <OnboardingMultipleChoiceQuestion
//                 question={currentQuestion}
//                 onNext={handleAnswerResult}
//               />
//             )}
//             {currentQuestion.questiontypeid === "2" && (
//               <OnboardingTrueFalseQuestion
//                 question={currentQuestion}
//                 onNext={handleAnswerResult}
//               />
//             )}
//             {currentQuestion.questiontypeid === "3" && (
//               <OnboardingMatchTheFollowingQuestion
//                 question={currentQuestion}
//                 onNext={handleAnswerResult}
//               />
//             )}
//             {currentQuestion.questiontypeid === "6.1" && (
//               <OnboardingMultipleChoiceQuestionChart
//                 question={currentQuestion}
//                 onNext={handleAnswerResult}
//               />
//             )}
//           </>
//         ) : (
//           <p>Loading questions...</p>
//         )}
//       </div>
//     </>
//   );
// };

// export default OnboardingSkillTest;
